<template>
	<div class="row">
		<div class="col-12 text-center" v-if="!item">
			<div class="spinner-grow" role="status">
				<span class="sr-only">Loading...</span>
			</div>
		</div>

		<!-- main toolbar -->
		<div class="col-12" v-if="item">
			<div class="card">
				<div class="card-body">

					<div class="form-group float-left mr-2">
						<label for="item_name">Показывать на сайте</label><br>

						<input type="checkbox" id="switch_show" v-model="item.show" data-switch="success"
							@change="editItem()" />
						<label for="switch_show" data-on-label="Да" data-off-label="Нет"></label>
					</div>

					<div class="form-group float-left mr-2">
						<label for="item_name">Перейти на страницу на сайте</label><br>

						<a :href="app_frontend_host + `/blog/post/${item._id}?preview=true`"
							class="btn btn-sm btn-rounded btn-outline-primary" target="_blank">перейти</a>
					</div>

					<div class="form-group float-left">
						<label for="item_name">Просмотров</label><br>
						<label> <i class="mdi mdi-eye"></i> {{ item.views }}</label>
					</div>
				</div>
			</div>
		</div>

		<div class="col-md-12 col-lg-6" v-if="item">
			<div class="card">
				<div class="card-body">

					<div class="form-group">
						<label>Краткое описание</label>
						<vue-editor v-model="item.description"
							:editorToolbar='[["bold", "italic", "underline"]]'></vue-editor>
					</div>

					<div class="form-group">
						<label>Статья</label>
						<vue-editor v-model="item.post" :useCustomImageHandler="true"
							@image-added="editorImgageUpload"></vue-editor>
					</div>

					<button v-if="!loading" type="submit" class="btn btn-primary"
						@click.prevent="editItem()">Сохранить</button>
					<button v-else class="btn btn-primary" type="button" disabled>
						<span class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
						Отправка данных...
					</button>

				</div>
			</div>
		</div>

		<div class="col-md-12 col-lg-6" v-if="item">
			<div class="card">
				<div class="card-body">

					<div class="form-group text-center">
						<label>Обложка</label>
						<vue-dropzone ref="dropzone_cover" id="dropzone_cover" :options="dropzone_cover"
							@vdropzone-sending="beforeImageUpload('cover', 'dropzone_cover', ...arguments)"
							@vdropzone-success="imageUploadSuccess('cover', 'dropzone_cover', ...arguments)"></vue-dropzone>
						<img :src="getCDNUrl(item.cover.path)" v-if="item.cover && item.cover.path" class="img-fluid mt-2">
					</div>

					<div class="form-group mr-2">
						<label for="item_name">Показывать обложку в статье</label><br>

						<input type="checkbox" id="switch_show_cover" v-model="item.show_cover" data-switch="success"
							@change="editItem()" />
						<label for="switch_show_cover" data-on-label="Да" data-off-label="Нет"></label>
					</div>

					<div class="form-group">
						<label>Название</label>
						<input type="text" v-model="item.title" class="form-control">
					</div>

					<div class="form-group">
						<label>Ссылка <small>(читаемая ссылка на страницу)</small></label>
						<input type="text" v-model="item.url" class="form-control">
						<input type="text" v-model="item.url_slug" disabled class="form-control">
					</div>

					<div class="form-group">
						<label>Категория статьи</label>
						<select class="form-control" v-model="item.category">
							<option v-for="(value, key) in filteredCategories" :key="key" :value="value._id">{{ value.title
							}}</option>
						</select>
					</div>

					<hr>

					<h5>SEO settings</h5>
					<button v-if="!ai_loading" type="button" class="btn btn-info" @click.prevent="aiSEO()">заполнить с
						помощью AI</button>
					<button v-else class="btn btn-info" type="button" disabled>
						<span class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
						Отправка данных...
					</button>

					<p>Важно, чтобы статья была полностью написана, чтобы AI смог взять ее как за контекст</p>

					<div class="form-group">
						<label>SEO title</label>
						<input type="text" v-model="item.seo.title" class="form-control">
					</div>

					<div class="form-group">
						<label>SEO description</label>
						<textarea v-model="item.seo.description" class="form-control"></textarea>
					</div>

					<div class="form-group">
						<label>SEO keywords</label>
						<input type="text" v-model="item.seo.keywords" class="form-control">
					</div>


					<button v-if="!loading" type="submit" class="btn btn-primary"
						@click.prevent="editItem()">Сохранить</button>
					<button v-else class="btn btn-primary" type="button" disabled>
						<span class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
						Отправка данных...
					</button>

				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import { VueEditor } from "vue2-editor";
import vue2Dropzone from 'vue2-dropzone'

import log from '@/plugins/log'
import { to } from '@/plugins/utils'
import '@/plugins/quill'

import 'vue2-dropzone/dist/vue2Dropzone.min.css'

export default {
	name: 'UserAdd',
	data: () => {
		return {
			item: null,
			loading: false,
			ai_loading: false,

			categories: [],

			dropzoneOptions: {
				paramName: "image",
				acceptedFiles: 'image/*',
				parallelUploads: 1,
				createImageThumbnails: false
			}
		}
	},
	computed: {
		...mapState([
			'app_mongo_desc',
			'app_cdn_host',
			'backend_url',
			'app_token',
			'app_frontend_host'
		]),
		id() {
			return this.$route.params.id
		},

		filteredCategories() {
			return this.categories.filter(item => {
				if (item.deleted || !item.show) return false

				return true
			})
		},

		dropzone_cover() {
			return Object.assign({}, this.dropzoneOptions, {
				url: this.backend_url + '/blog/uploadImage/' + this.id,
				maxFiles: 1,
				headers: {
					'Authorization': this.app_token
				}
			})
		},
	},
	async beforeMount() {
		await this.getItem()
		await this.getCategories()
	},
	mounted() {
		log.debug(`/views/blog/edit/${this.id}`, 'mounted')
	},
	watch: {
		'item.url': function (newVal, oldVal) {
			this.item.url_slug = cyr2lat(newVal).toLocaleLowerCase()
		}
	},
	methods: {
		async getItem() {
			var [err, response] = await to(this.$http.get(`/blog/edit/${this.id}`))
			if (err) {
				log.error(`/views/blog/edit/${this.id}`, 'methods.getItem', '$http.request', err)
				return $.NotificationApp.send("Ошибка", err.message, "top-right", "", "error")
			}

			if (!response.data.success) {
				log.error(`/views/blog/edit/${this.id}`, 'methods.getItem', '$http.response', response.data)
				return $.NotificationApp.send("Ошибка", response.data.error, "top-right", "", "error")
			}

			log.debug('/views/blog/add', 'methods.getItem', '$http.request', response.data)
			response.data.item.password = ''

			this.item = response.data.item
		},
		async getCategories() {
			var [err, response] = await to(this.$http.get(`/blog_category/list/`))
			if (err) {
				log.error(`/views/blog/edit/${this.id}`, 'methods.getCategories', '$http.request', err)
				return $.NotificationApp.send("Ошибка", err.message, "top-right", "", "error")
			}

			if (!response.data.success) {
				log.error(`/views/blog/edit/${this.id}`, 'methods.getCategories', '$http.response', response.data)
				return $.NotificationApp.send("Ошибка", response.data.error, "top-right", "", "error")
			}

			log.debug(`/views/blog/edit/${this.id}`, 'methods.getCategories', '$http.request', response.data)

			this.categories = response.data.items
		},

		async editItem() {
			this.loading = true
			var [err, response] = await to(this.$http.post(`/blog/edit/${this.id}`, this.item))
			if (err) {
				this.loading = false
				log.error(`/views/blog/edit/${this.id}`, 'methods.editItem', '$http.request', err)
				return $.NotificationApp.send("Ошибка", err.message, "top-right", "", "error")
			}

			if (!response.data.success) {
				this.loading = false
				log.error(`/views/blog/edit/${this.id}`, 'methods.editItem', '$http.response', response.data)
				return $.NotificationApp.send("Ошибка", response.data.error, "top-right", "", "error")
			}

			this.loading = false
			log.debug(`/views/blog/edit/${this.id}`, 'methods.editItem', '$http.request', response.data)
			$.NotificationApp.send("Успешно", '', "top-right", "", "success")

			this.item = response.data.item
		},

		async aiSEO() {
			this.ai_loading = true;

			var [err, response] = await to(this.$http.post(`/seo/generate`, {
				prompt: [
					`Type: Blog article`,
					`Title: ${this.item.title}`,
					`Article: ${this.item.post.replace(/<img .*?>/g, '')}`,
				].join(';')
			}))

			if (err) {
				this.ai_loading = false
				log.error(`/views/blog/edit/${this.id}`, 'methods.aiSEO', '$http.request', err)
				return $.NotificationApp.send("Ошибка", err.message, "top-right", "", "error")
			}

			if (!response.data.success) {
				this.ai_loading = false
				log.error(`/views/blog/edit/${this.id}`, 'methods.aiSEO', '$http.response', response.data)
				return $.NotificationApp.send("Ошибка", response.data.error, "top-right", "", "error")
			}

			this.ai_loading = false

			this.item.seo.title = response.data.result.title;
			this.item.seo.description = response.data.result.description;
			this.item.seo.keywords = response.data.result.keywords;
		},

		/* dropzone upload */
		beforeImageUpload(type, ref, file, xhr, formData) {
			formData.append('type', type)
		},
		imageUploadSuccess(type, ref, file, response) {
			if (!response.success) {
				log.error(`/views/blog/edit/${this.id}`, 'methods.imageUploadSuccess', '$http.response', response)
				return $.NotificationApp.send("Ошибка", response.error, "top-right", "", "error")
			}

			if (type == 'cover') {
				this.item.cover = {
					url: this.getCDNUrl(response.image.imagePath),
					path: response.image.imagePath
				}
				this.editItem()

				this.$refs[ref].removeAllFiles()
			}
		},

		/* editor upload */
		async editorImgageUpload(file, Editor, cursorLocation, resetUploader) {
			var formData = new FormData();
			formData.append("image", file, file.name);
			formData.append("type", 'post');

			var [err, response] = await to(this.$http.post(`/blog/uploadImage/${this.id}`, formData))
			if (err) {
				log.error(`/views/blog/edit/${this.id}`, 'methods.editorImgageUpload', '$http.request', err)
				return $.NotificationApp.send("Ошибка", err.message, "top-right", "", "error")
			}
			if (!response.data.success) {
				log.error(`/views/blog/edit/${this.id}`, 'methods.editorImgageUpload', '$http.response', response)
				return $.NotificationApp.send("Ошибка", response.data.error, "top-right", "", "error")
			}
			log.debug('/views/blog/add', 'methods.editorImgageUpload', '$http.request', response.data)

			Editor.insertEmbed(cursorLocation, "imageBlot", {
				src: this.getCDNUrl(response.data.image.imagePath),
				path: response.data.image.imagePath
			});
			resetUploader();
		},

		getCDNUrl(path, modify = []) {
			let modification_string = modify.length ? modify.join(',') + '/_/' : ''
			return `${this.app_cdn_host}/i/${modification_string}${path}`
		}
	},
	components: {
		VueEditor,
		vueDropzone: vue2Dropzone,
	},
};

function cyr2lat(str) {
	var cyr2latChars = new Array(['а', 'a'], ['б', 'b'], ['в', 'v'], ['г', 'g'], ['д', 'd'], ['е', 'e'], ['ё', 'yo'], ['ж', 'zh'], ['з', 'z'], ['и', 'i'], ['й', 'y'], ['к', 'k'], ['л', 'l'], ['м', 'm'], ['н', 'n'], ['о', 'o'], ['п', 'p'], ['р', 'r'], ['с', 's'], ['т', 't'], ['у', 'u'], ['ф', 'f'], ['х', 'h'], ['ц', 'c'], ['ч', 'ch'], ['ш', 'sh'], ['щ', 'shch'], ['ъ', ''], ['ы', 'y'], ['ь', ''], ['э', 'e'], ['ю', 'yu'], ['я', 'ya'], ['А', 'A'], ['Б', 'B'], ['В', 'V'], ['Г', 'G'], ['Д', 'D'], ['Е', 'E'], ['Ё', 'YO'], ['Ж', 'ZH'], ['З', 'Z'], ['И', 'I'], ['Й', 'Y'], ['К', 'K'], ['Л', 'L'], ['М', 'M'], ['Н', 'N'], ['О', 'O'], ['П', 'P'], ['Р', 'R'], ['С', 'S'], ['Т', 'T'], ['У', 'U'], ['Ф', 'F'], ['Х', 'H'], ['Ц', 'C'], ['Ч', 'CH'], ['Ш', 'SH'], ['Щ', 'SHCH'], ['Ъ', ''], ['Ы', 'Y'], ['Ь', ''], ['Э', 'E'], ['Ю', 'YU'], ['Я', 'YA'], ['a', 'a'], ['b', 'b'], ['c', 'c'], ['d', 'd'], ['e', 'e'], ['f', 'f'], ['g', 'g'], ['h', 'h'], ['i', 'i'], ['j', 'j'], ['k', 'k'], ['l', 'l'], ['m', 'm'], ['n', 'n'], ['o', 'o'], ['p', 'p'], ['q', 'q'], ['r', 'r'], ['s', 's'], ['t', 't'], ['u', 'u'], ['v', 'v'], ['w', 'w'], ['x', 'x'], ['y', 'y'], ['z', 'z'], ['A', 'A'], ['B', 'B'], ['C', 'C'], ['D', 'D'], ['E', 'E'], ['F', 'F'], ['G', 'G'], ['H', 'H'], ['I', 'I'], ['J', 'J'], ['K', 'K'], ['L', 'L'], ['M', 'M'], ['N', 'N'], ['O', 'O'], ['P', 'P'], ['Q', 'Q'], ['R', 'R'], ['S', 'S'], ['T', 'T'], ['U', 'U'], ['V', 'V'], ['W', 'W'], ['X', 'X'], ['Y', 'Y'], ['Z', 'Z'], [' ', '-'], ['0', '0'], ['1', '1'], ['2', '2'], ['3', '3'], ['4', '4'], ['5', '5'], ['6', '6'], ['7', '7'], ['8', '8'], ['9', '9'], ['-', '-']);

	var newStr = new String();

	for (var i = 0; i < str.length; i++) {

		var ch = str.charAt(i);
		var newCh = '';
		for (var j = 0; j < cyr2latChars.length; j++) {
			if (ch == cyr2latChars[j][0]) {
				newCh = cyr2latChars[j][1];
			}
		}
		newStr += newCh;
	}
	return newStr.replace(/[-]{2,}/gim, '-').replace(/\n/gim, '');
}
</script>